import React from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

// Native accordion (grid-rows trick), same idiom as screens/FQA — replaces
// the old Material-UI Collapse-based accordion.
const Program = ({ title, children }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div
      className={`overflow-hidden rounded-2xl border bg-white transition-all duration-200 ${
        isOpen
          ? "border-brand-200 shadow-card-hover"
          : "border-slate-100 shadow-card hover:border-slate-200"
      }`}
    >
      <button
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((v) => !v)}
        className="flex w-full items-center gap-3 px-4 py-3.5 text-start sm:px-5"
      >
        <h4 className="flex-1 text-sm font-semibold text-ink sm:text-base">{title}</h4>
        <ChevronDownIcon
          className={`h-5 w-5 shrink-0 text-ink-subtle transition-transform duration-300 ${
            isOpen ? "rotate-180 text-brand-500" : ""
          }`}
        />
      </button>
      <div
        className={`grid transition-all duration-300 ease-out ${
          isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <div className="prose prose-sm max-w-none px-4 pb-4 text-ink-muted sm:px-5 sm:pb-5 [&_p]:my-1.5">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Program;
